<template>
    <nav class="sticky top-0 z-50 bg-black/95 backdrop-blur-xl border-b border-white/10">
        <div class="max-w-[1400px] mx-auto px-4 sm:px-6 py-3">
            <div class="flex items-center justify-between gap-3">
                <!-- Left: Logo - Star on Mobile, Full on Desktop -->
                <a href="/" class="flex-shrink-0">
                    <!-- Mobile: Star Icon only (matches sidebar) -->
                    <img
                        src="https://sm.naughtycdn.com/images/landers/prize/NA-Star.png"
                        alt="Naughty America"
                        class="h-8 w-8 sm:hidden"
                    />

                    <!-- Desktop: Full Logo + Tagline -->
                    <div class="hidden sm:block">
                        <img
                            src="https://sm.naughtycdn.com/images/www/naughty-america-logo.png"
                            alt="Naughty America"
                            class="h-6"
                        />
                        <p class="text-white/50 text-xs mt-1 tracking-wide">
                            14k+ Videos • Monthly Stars Included
                        </p>
                    </div>
                </a>

                <!-- Right: Navigation Buttons -->
                <div class="flex items-center gap-1 sm:gap-3 flex-shrink-0">
                    <Link
                        :href="getMainAuditionsUrl(isUserLoggedIn, routePrefix)"
                        @click="handleAuditionsClick"
                        class="px-1.5 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-blue-600/10 border border-blue-500/50 text-blue-400 text-[10px] sm:text-xs font-semibold transition-all whitespace-nowrap min-h-[44px] flex items-center uppercase tracking-wide"
                    >
                        Auditions
                    </Link>

                    <Link
                        :href="getCastingsUrl(isUserLoggedIn, routePrefix)"
                        @click="handlePitchesClick"
                        class="px-1.5 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-purple-600/10 border border-purple-500/50 text-purple-400 text-[10px] sm:text-xs font-semibold transition-all whitespace-nowrap min-h-[44px] flex items-center uppercase tracking-wide"
                    >
                        Pitches
                    </Link>

                    <!-- + Casting modal button — shown only on TagPageV2 -->
                    <Link
                        :href="getCreateCastingUrl(isUserLoggedIn, routePrefix)"
                        @click="handleCreateCastingClick"
                        class="relative px-1.5 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-amber-500/15 hover:bg-amber-500/25 border border-amber-500/50 hover:border-amber-400/70 text-amber-300 hover:text-amber-200 text-[10px] sm:text-xs font-semibold transition-all active:scale-95 whitespace-nowrap min-h-[44px] flex items-center gap-0.5 sm:gap-1.5 uppercase tracking-wide shadow-[0_0_14px_rgba(245,158,11,0.15)]"
                    >
                        <Plus class="w-3 h-3 sm:w-3.5 sm:h-3.5 shrink-0" />
                        <span>Create</span>
                        <span class="absolute -top-1.5 -right-1.5 sm:-top-2 sm:-right-2 bg-amber-400 text-black text-[8px] sm:text-[9px] font-bold px-1 sm:px-1.5 py-0.5 rounded-full leading-none">NEW</span>
                    </Link>

                    <a
                        v-if="
                                false // hidden for now.
                            // !requiresAgeVerification && !hide.videos
                        "
                        :href="isUserLoggedIn ? route('members2.main.home') : route('www.main.home')"
                        class="px-1.5 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-white/10 hover:bg-white/15 border border-white/10 text-white text-[10px] sm:text-xs font-semibold transition-all active:scale-95 whitespace-nowrap min-h-[44px] flex items-center uppercase tracking-wide"
                    >
                        <span class="hidden sm:inline">14k+ Videos</span>
                        <span class="sm:hidden">Videos</span>
                    </a>

                    <button
                        v-if="
                            false // hiden for now.
                            // !isUserLoggedIn && !hide.getStars
                        "
                        @click="$emit('joinClick')"
                        class="hidden sm:flex px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold transition-all active:scale-95 whitespace-nowrap min-h-[44px] items-center uppercase tracking-wide"
                    >
                        Get Stars
                    </button>

                    <button
                        v-if="!isUserLoggedIn && !hide.join"
                        @click="$emit('joinClick')"
                        class="hidden sm:flex px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold transition-all active:scale-95 whitespace-nowrap min-h-[44px] items-center uppercase tracking-wide"
                    >
                        Join Free
                    </button>

                    <a
                        v-if="!isUserLoggedIn && !hide.signIn"
                        :href="route('members2.auth.login', { dest: currentUrl })"
                        class="px-1.5 sm:px-4 py-1.5 sm:py-2 rounded-lg bg-white/10 hover:bg-white/15 border border-white/10 text-white text-[10px] sm:text-xs font-semibold transition-all active:scale-95 whitespace-nowrap min-h-[44px] flex items-center uppercase tracking-wide"
                    >
                        Sign In
                    </a>

                    <!-- Wallet balance — logged-in users only -->
                    <!--<button
                        v-if="isUserLoggedIn"
                        @click="$emit('buyStarsClick')"
                        class="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 min-h-[44px] transition-colors active:scale-95"
                    >
                        <img
                            src="https://sm.naughtycdn.com/images/landers/prize/NA-Star.png"
                            alt="Stars"
                            class="w-4 h-4 shrink-0"
                        />
                        <span class="text-white font-bold text-xs tabular-nums">{{ walletBalance }}</span>
                    </button>-->

                    <KebabMenu
                        v-if="!hide.kebab"
                        :isUserLoggedIn="isUserLoggedIn"
                        :isGoldUser="isGoldUser"
                        :starBalance="walletBalance"
                        variant="default"
                        :routePrefix="routePrefix"
                        :requiresAgeVerification="requiresAgeVerification"
                        @joinClick="$emit('joinClick')"
                        @goldJoinClick="$emit('goldJoinClick')"
                        @update:open="$emit('update:kebabOpen', $event)"
                    />
                </div>
            </div>
        </div>
    </nav>
</template>

<script setup>
import KebabMenu from "@/Components/Reels/KebabMenu.vue";
import {Link, usePage} from "@inertiajs/vue3";
import {getCastingsUrl, getCreateCastingUrl, getMainAuditionsUrl} from "@/Helpers/auditions";
import {computed} from "vue";
import {getFathomPagePrefix, trackEvent, trackFathomEvent} from "@/Helpers/analytics";
import {Clapperboard, Plus} from "lucide-vue-next";

defineProps({
    isUserLoggedIn: {
        type: Boolean,
        required: true
    },
    isGoldUser: {
        type: Boolean,
        required: true
    },
    routePrefix: {
        type: String
    },
    requiresAgeVerification: {
        type: Boolean,
        required: true
    },
    // Pass an object to selectively hide header elements.
    // Recognised keys: videos | getStars | kebab, join, signIn
    // Example: :hide="{ videos: true, kebab: true }"
    hide: {
        type: Object,
        default: () => ({
            videos: false,
            getStars: false,
            kebab: false,
            join: true,
            signIn: true,
        })
    },
})

const emit = defineEmits([
    'joinClick',
    'update:kebabOpen',
    'goldJoinClick',
    'buyStarsClick',
])

const { props } = usePage();

const walletBalance = computed(() => (Number(props.auth?.user?.wallet_balance) || 0))

const currentUrl = computed(() => {
    if (typeof window !== 'undefined' && window.location) {
        return window.location.pathname + window.location.search
    }
    return ''
})

const handleCreateCastingClick = () => {
    trackFathomEvent(getFathomPagePrefix(props.routePrefix) + '_Top_Menu_Create_Casting_Button_Clicked')
    trackEvent('Top Menu Create Casting Button Clicked')
}

const handlePitchesClick = () => {
    trackFathomEvent(getFathomPagePrefix(props.routePrefix) + '_Top_Menu_Pitches_Button_Clicked')
    trackEvent('Top Menu Pitches Button Clicked')
}

const handleAuditionsClick = () => {
    trackFathomEvent(getFathomPagePrefix(props.routePrefix) + 'Top Menu Auditions Button Clicked')
    trackEvent('Top Menu Auditions Button Clicked')
}
</script>
